import React from 'react';
import Dashboard from './pages/dashboard';
import InquiryItems from './pages/inquiry/InquiryItems';
import InquiryInfo from './pages/inquiry/InquiryInfo';
import SalesEstimation from './pages/sales/sales_estimation';
import SalesBrowser from './pages/sales/sales_browser';
import SalesDataCustomer from './pages/sales/sales_data_customer';
import CloseOrder from './pages/sales/close_order';
import SalesAddLine from './pages/sales/sales_add_line';
import PurchaseRequest from './pages/inventory/purchase_request';
import AddLinePr from './pages/inventory/add_line_pr';
import BrowserPurchaseRequest from './pages/inventory/browser_purchase_request';
import GoodsReceive from './pages/inventory/goods_receive';
import ClaimSupplier from './pages/inventory/claim_supplier';
import GoodsReceiveReturn from './pages/inventory/goods_receive_return';
import ItemWHTransferRequest from './pages/inventory/item_wh_transfer_request';
import DataWhTransferRequest from './pages/inventory/data_wh_transfer_request';
import ItemLocationTransfer from './pages/inventory/item_location_transfer';
import StockOpname from './pages/inventory/stock_opname';
import StockOpnameAnalysis from './pages/inventory/stock_opname_analysis';
import PickingList from './pages/admin/picking_list';
import BrowserPickingList from './pages/admin/browser_picking_list';
import PickingListReturn from './pages/admin/picking_list_return';
import DataPickingReturn from './pages/admin/data_picking_return';
import SalesOrderInvoiceReturn from './pages/admin/sales_order_invoice_return';
import DataSalesOrderInvoiceReturn from './pages/admin/data_sales_order_invoice_return';
import SalesOrderInvoice from './pages/admin/sales_order_invoice';
import BrowserSalesOrderInvoice from './pages/admin/browser_sales_order_invoice';
import CashManagementInBatch from './pages/admin/cash_management_in_batch';
import DataCashInvoice from './pages/admin/data_cash_invoice';
import BrowserDataCashInvoice from './pages/admin/browser_data_cash_invoice';
import ReycleBin from './pages/admin/reycle_bin';
import BrowserTransactionInvoice from './pages/admin/browser_transaction_invoice';
import TransactionInvoice from './pages/admin/transaction_invoice';
import CustomerMaster from './pages/admin/customer_master';
import SupplierMaster from './pages/admin/supplier_master';
import BrowserSupplierMaster from './pages/admin/browser_supplier_master';
import SpKppCode from './pages/admin/sp_kpp_code';
import SpCop from './pages/admin/sp_cop';
import SpBank from './pages/admin/sp_bank';
import PackingList from './pages/admin/packing_list';
import BrowserPacking from './pages/admin/browser_packing_list';
import SupplySlip from './pages/service/supply_slip/supply_slip';
import SupplyReturn from './pages/supply_return';
import Error404 from './pages/404';
import LoginPage from './pages/login_page';
import Agreement from './pages/admin/agreement';
import BrowserAgreement from './pages/admin/browser_agreement';
import DataWarehouse from './pages/admin/warehouse';
import BrowserWarehouse from './pages/admin/browser_warehouse';
import SparePartsMaster from './pages/inventory/spareparts_master';
import BrowserDataSpareparts from './pages/inquiry/browser_data_spareparts';
import DataCustomerMaster from './pages/admin/data_customer_master';
import ManagementUser from './pages/setting/management_user';
import ListUser from './pages/setting/list_user';
import DataGoodsReceive from './pages/inventory/data_goods_receive';
import DataGoodsReceiveReturn from './pages/inventory/data_goods_receive_return';
import PurchaseOrder from './pages/inventory/purchase_order';
import DataPurchaseOrder from './pages/inventory/data_purchase_order';
import SparepartSalesCustomer from './pages/sales/sparepart_sales_customer';
import RequestPartSales from './pages/sales/request_part_sales';
import SalesSubstitution from './pages/sales/sales_substitution';
import DataSubs from './pages/sales/data_subs';
import ItemLocation from './pages/inventory/item_location';
import HistoryDataItemLocation from './pages/inventory/history_data_item_location';
import SettingUpdateItemPart from './pages/setting/setting_update_item_spareparts';
import ItemWhTransferReceipt from './pages/inventory/item_wh_transfer_receipt';
import ItemWHTransferIn from './pages/inventory/item_wh_transfer_in';
import ItemWHTransferOut from './pages/inventory/item_wh_transfer_out';
import DataTransferWhOut from './pages/inventory/data_wh_transfer_out';
import DataWhTransferIn from './pages/inventory/data_wh_transfer_in';
import VehicleMaster from './pages/service/vehicle_master';
import DataVehicleMaster from './pages/service/data_vehicle_master';
import WorkOrder from './pages/service/work_order';
import DataWorkOrder from './pages/service/data_work_order';
import WorkOrderAllocation from './pages/service/work_order_allocation/work_order_allocation';
import ForemanData from './pages/setting/foreman_data';
import BrowserDataForeman from './pages/setting/browser_data_foreman';
import AttendanceMechanic from './pages/service/attendance_mechanic';
import AllocateWorkOrder from './pages/service/work_order_allocation/allocate_work_order';
import ServiceItemMaster from './pages/service/item_master/service_item_master';
import DataServiceItemMaster from './pages/service/item_master/data_service_item_master';
import ListMechanicWorkOrderAllocate from './pages/service/work_order_allocation/list_mechanic_work_order_allocate';
import DataAllocateWorkOrder from './pages/service/work_order_allocation/data_allocate_work_order';
import WorkOrderInvoice from './pages/service/invoice/work_order_invoice';
import DataSupplySlip from './pages/service/supply_slip/data_supply_slip';
import supply_slip_return from './pages/service/supply_slip_return/supply_slip_return';
import setting_overtime_work_allocation from './pages/setting/setting_overtime_work_allocation';
import data_invoice_work_order from './pages/service/invoice/data_invoice_work_order';
import DataSupplySlipReturn from './pages/service/supply_slip_return/data_supply_slip_return';
import InvoiceReturnWorkOrder from './pages/service/invoice_return/invoice_return_work_order';
import DataInvoiceReturnWorkOrder from './pages/service/invoice_return/data_invoice_return_work_order';
import sales_invoice_profit_report from './pages/sales/sales_invoice_profit_report';
import status_import_spareparts_master from './pages/inventory/status_import_spareparts_master';
import menu_approval from './pages/superuser/menu_approval';
import rack_location from './pages/inventory/rack_location';
import DataAttMechanic from './pages/service/data_attendance_mechanic';
import export_part from './pages/inventory/export_part';
import adjustment from './pages/inventory/adjusment/adjustment';
import data_adjustment from './pages/inventory/adjusment/data_adjustment';
import MenuSql from './pages/superuser/menu_sql';
import LogSpareparts from './pages/superuser/log_spareparts/log_spareparts';
import WorkOrderReport from './pages/service/work_order_report/work_order_report';



export interface RouteConfig {
    path: string;
    component: React.ComponentType<any>;
    id: string;
    menuName: string;
    wrapperClass: string;
    isHoc?: boolean;
    hocWrapper?: (Component: React.ComponentType<any>) => React.ComponentType<any>;
}

export const dashboardRoutes: RouteConfig[] = [
    {
        path: "data_customer_master",
        component: DataCustomerMaster,
        id: "101",
        menuName: "Data Customer Master",
        wrapperClass: "data_customer_master"
    },
    {
        path: "sales_estimation",
        component: SalesEstimation,
        id: "102",
        menuName: "Sales Estimation",
        wrapperClass: "sales_estimation"
    },
    {
        path: "sales_browser",
        component: SalesBrowser,
        id: "103",
        menuName: "Sales Browser",
        wrapperClass: "sales_browser"
    },
    {
        path: "goods_receive",
        component: GoodsReceive,
        id: "104",
        menuName: "Goods Receive",
        wrapperClass: "goods_receive"
    },
    {
        path: "browser_agreement",
        component: BrowserAgreement,
        id: "105",
        menuName: "Browser Agreement",
        wrapperClass: "browser_agreement"
    },
    {
        path: "agreement",
        component: Agreement,
        id: "106",
        menuName: "Agreement",
        wrapperClass: "agreement"
    },
    {
        path: "purchase_request",
        component: PurchaseRequest,
        id: "107",
        menuName: "Purchase Request",
        wrapperClass: "purchase_request"
    },
    {
        path: "purchase_request/edit/:id",
        component: PurchaseRequest,
        id: "108",
        menuName: "Purchase Request",
        wrapperClass: "purchase_request"
    },
    {
        path: "browser_purchase_request",
        component: BrowserPurchaseRequest,
        id: "109",
        menuName: "Browser Purchase Request",
        wrapperClass: "browser-pr"
    },
    {
        path: "purchase_order",
        component: PurchaseOrder,
        id: "112",
        menuName: "Purchase Order",
        wrapperClass: "purchase_order",
    },
    {
        path: "data_purchase_order",
        component: DataPurchaseOrder,
        id: "148",
        menuName: "Data Purchase Order",
        wrapperClass: "data_purchase_order",
    },
    {
        path: "browser_warehouse",
        component: BrowserWarehouse,
        id: "113",
        menuName: "Browser Warehouse",
        wrapperClass: "browser_warehouse"
    },
    {
        path: "supplier_master",
        component: SupplierMaster,
        id: "114",
        menuName: "Supplier Master",
        wrapperClass: "supplier_master"
    },
    {
        path: "supplier_master/:supplierId",
        component: SupplierMaster,
        id: "115",
        menuName: "Supplier Master",
        wrapperClass: "supplier_master"
    },
    {
        path: "browser_supplier_master",
        component: BrowserSupplierMaster,
        id: "116",
        menuName: "Browser Supplier Master",
        wrapperClass: "browser_supplier_master"
    },
    {
        path: "sp_cop",
        component: SpCop,
        id: "117",
        menuName: "Sp Cop",
        wrapperClass: "sp_cop"
    },
    {
        path: "sp_bank",
        component: SpBank,
        id: "118",
        menuName: "Sp Bank",
        wrapperClass: "sp_bank"
    },
    {
        path: "inquiryitems",
        component: InquiryItems,
        id: "119",
        menuName: "Inquiry Items",
        wrapperClass: "inquiry"
    },
    {
        path: "inquiryinfo",
        component: InquiryInfo,
        id: "156",
        menuName: "Inquiry Info",
        wrapperClass: "inquiryinfo"
    },
    {
        path: "spareparts_master",
        component: SparePartsMaster,
        id: "120",
        menuName: "Spare Parts Master",
        wrapperClass: "spareparts_master"
    },
    {
        path: "spareparts_master/:id",
        component: SparePartsMaster,
        id: "121",
        menuName: "Spare Parts Master",
        wrapperClass: "spareparts_master"
    },
    {
        path: "browser_data_spareparts",
        component: BrowserDataSpareparts,
        id: "122",
        menuName: "Browser Data Spareparts",
        wrapperClass: "browser_data_spareparts"
    },
    {
        path: "picking_list",
        component: PickingList,
        id: "123",
        menuName: "Picking List",
        wrapperClass: "picking_list"
    },
    {
        path: "browser_picking_list",
        component: BrowserPickingList,
        id: "124",
        menuName: "Browser Picking List",
        wrapperClass: "browser_picking_list"
    },
    {
        path: "packing_list",
        component: PackingList,
        id: "125",
        menuName: "Packing List",
        wrapperClass: "packing_list"
    },
    {
        path: "browser_packing_list",
        component: BrowserPacking,
        id: "126",
        menuName: "Browser Packing",
        wrapperClass: "browser_packing"
    },
    {
        path: "sales_order_invoice",
        component: SalesOrderInvoice,
        id: "127",
        menuName: "Sales Order Invoice",
        wrapperClass: "sales_order_invoice"
    },
    {
        path: "browser_sales_order_invoice",
        component: BrowserSalesOrderInvoice,
        id: "128",
        menuName: "Browser Sales Order Invoice",
        wrapperClass: "browser_sales_order_invoice"
    },
    {
        path: "picking_list_return",
        component: PickingListReturn,
        id: "129",
        menuName: "Picking List Return",
        wrapperClass: "picking_list_return"
    },
    {
        path: "data_picking_return",
        component: DataPickingReturn,
        id: "130",
        menuName: "Data Picking Return",
        wrapperClass: "data_picking_return"
    },
    {
        path: "customer_master",
        component: CustomerMaster,
        id: "131",
        menuName: "Customer Master",
        wrapperClass: "customer_master"
    },
    {
        path: "management_user",
        component: ManagementUser,
        id: "132",
        menuName: "Management User",
        wrapperClass: "management_user"
    },
    {
        path: "warehouse",
        component: DataWarehouse,
        id: "133",
        menuName: "Data Warehouse",
        wrapperClass: "warehouse"
    },
    {
        path: "loginpage",
        component: DataWarehouse,
        id: "134",
        menuName: "Login Page",
        wrapperClass: "login_page"
    },
    {
        path: "list_user",
        component: ListUser,
        id: "135",
        menuName: "List User",
        wrapperClass: "list_user"
    },
    {
        path: "data_goods_receive",
        component: DataGoodsReceive,
        id: "136",
        menuName: "Data Goods Receive",
        wrapperClass: "data_goods_receive"
    },
    {
        path: "goods_receive_return",
        component: GoodsReceiveReturn,
        id: "137",
        menuName: "Goods Receive Return",
        wrapperClass: "goods_receive_return"
    },
    {
        path: "data_goods_receive_return",
        component: DataGoodsReceiveReturn,
        id: "138",
        menuName: "Data Goods Receive Return",
        wrapperClass: "data_goods_receive_return"
    },
    {
        path: "item_wh_transfer_request",
        component: ItemWHTransferRequest,
        id: "139",
        menuName: "Item WH Transfer Request",
        wrapperClass: "item_wh_transfer_request"
    },
    {
        path: "data_wh_transfer_request",
        component: DataWhTransferRequest,
        id: "140",
        menuName: "Data Wh Transfer Request",
        wrapperClass: "data_wh_transfer_request"
    },
    {
        path: "sales_order_invoice_return",
        component: SalesOrderInvoiceReturn,
        id: "141",
        menuName: "Sales Order Invoice Return",
        wrapperClass: "sales_order_invoice_return"
    },
    {
        path: "data_sales_order_invoice_return",
        component: DataSalesOrderInvoiceReturn,
        id: "142",
        menuName: "Data Sales Order Invoice Return",
        wrapperClass: "data_sales_order_invoice_return"
    },
    {
        path: "data_cash_invoice",
        component: DataCashInvoice,
        id: "143",
        menuName: "Data Cash Invoice",
        wrapperClass: "data_cash_invoice"
    },
    {
        path: "browser_data_cash_invoice",
        component: BrowserDataCashInvoice,
        id: "145",
        menuName: "Browser Data Cash Invoice",
        wrapperClass: "browser_data_cash_invoice"
    },
    {
        path: "transaction_invoice",
        component: TransactionInvoice,
        id: "144",
        menuName: "Transaction Invoice",
        wrapperClass: "transaction_invoice"
    },
    {
        path: "browser_transaction_invoice",
        component: BrowserTransactionInvoice,
        id: "146",
        menuName: "Browser Transaction Invoice",
        wrapperClass: "browser_transaction_invoice"
    },
    {
        path: "reycle_bin",
        component: ReycleBin,
        id: "147",
        menuName: "Reycle Bin Trans Invoice",
        wrapperClass: "reycle_bin"
    },
    {
        path: "sparepart_sales_customer",
        component: SparepartSalesCustomer,
        id: "149",
        menuName: "Sparepart Sales Customer",
        wrapperClass: "sparepart_sales_customer"
    },
    {
        path: "request_part_sales",
        component: RequestPartSales,
        id: "150",
        menuName: "Request Part Sales",
        wrapperClass: "request_part_sales"
    },
    {
        path: "sales_substitution",
        component: SalesSubstitution,
        id: "151",
        menuName: "Sales Substitution",
        wrapperClass: "sales_substitution"
    },
    {
        path: "data_subs",
        component: DataSubs,
        id: "152",
        menuName: "Data Subs",
        wrapperClass: "data_subs"
    },
    {
        path: "item_location",
        component: ItemLocation,
        id: "154",
        menuName: "Item Location",
        wrapperClass: "item_location"
    },
    {
        path: "history_data_item_location",
        component: HistoryDataItemLocation,
        id: "155",
        menuName: "History Data Item Location",
        wrapperClass: "history_data_item_location"
    },
    {
        path: "setting_update_item_spareparts",
        component: SettingUpdateItemPart,
        id: "157",
        menuName: "Setting Update Item Sparepart",
        wrapperClass: "setting_update_item_part"
    },
    {
        path: "item_wh_transfer_receipt",
        component: ItemWhTransferReceipt,
        id: "158",
        menuName: "Item Wh Transfer Receipt",
        wrapperClass: "item_wh_transfer_receipt"
    },
    {
        path: "data_wh_transfer_in",
        component: DataWhTransferIn,
        id: "162",
        menuName: "Data Wh Transfer In",
        wrapperClass: "data_wh_transfer_in"
    },
    {
        path: "item_wh_transfer_in",
        component: ItemWHTransferIn,
        id: "159",
        menuName: "Item Wh Transfer In",
        wrapperClass: "item_wh_transfers_in"
    },
    {
        path: "item_wh_transfer_out",
        component: ItemWHTransferOut,
        id: "160",
        menuName: "Item Wh Transfer Out",
        wrapperClass: "item_wh_transfer_out"
    },
    {
        path: "data_wh_transfer_out",
        component: DataTransferWhOut,
        id: "161",
        menuName: "Data Transfer Wh Out",
        wrapperClass: "data_wh_transfer_out"
    },
    {
        path: "vehicle_master",
        component: VehicleMaster,
        id: "201",
        menuName: "Vehicle Master",
        wrapperClass: "vehicle_master"
    },
    {
        path: "data_vehicle_master",
        component: DataVehicleMaster,
        id: "202",
        menuName: "Data Vehicle Master",
        wrapperClass: "data_vehicle_master"
    },
    {
        path: "work_order",
        component: WorkOrder,
        id: "203",
        menuName: "Work Order",
        wrapperClass: "work_order"
    },
    {
        path: "data_work_order",
        component: DataWorkOrder,
        id: "204",
        menuName: "Data Work Order",
        wrapperClass: "data_work_order"
    },
    {
        path: "work_order_allocation",
        component: WorkOrderAllocation,
        id: "205",
        menuName: "Work Order Allocation",
        wrapperClass: "work_order_allocation"
    },
    {
        path: "foreman_data",
        component: ForemanData,
        id: "001",
        menuName: "Foreman Data",
        wrapperClass: "foreman_data"
    },
    {
        path: "browser_data_foreman",
        component: BrowserDataForeman,
        id: "002",
        menuName: "Browser Data Foreman",
        wrapperClass: "browser_data_foreman"
    },
    {
        path: "data_attendance_mechanic",
        component: DataAttMechanic,
        id: "022",
        menuName: "Trans Attendance Mechanic",
        wrapperClass: "data_attendance_mechanic"
    },
    {
        path: "attendance_mechanic",
        component: AttendanceMechanic,
        id: "003",
        menuName: "Attendance Mechanic",
        wrapperClass: "attendance_mechanic"
    },
    {
        path: "allocate_work_order",
        component: AllocateWorkOrder,
        id: "004",
        menuName: "Allocate Work Order",
        wrapperClass: "allocate_work_order"
    },
    {
        path: "service_item_master",
        component: ServiceItemMaster,
        id: "005",
        menuName: "Service Item Master",
        wrapperClass: "service_item_master"
    },
    {
        path: "data_service_item_master",
        component: DataServiceItemMaster,
        id: "006",
        menuName: "Data Service Item Master",
        wrapperClass: "data_service_item_master"
    },
    {
        path: "list_mechanic_work_order_allocate",
        component: ListMechanicWorkOrderAllocate,
        id: "007",
        menuName: "List Mechanic Work Order Allocate",
        wrapperClass: "list_mechanic_work_order_allocate"
    },
    {
        path: "data_allocate_work_order",
        component: DataAllocateWorkOrder,
        id: "008",
        menuName: "Data Allocate Work Order",
        wrapperClass: "data_allocate_work_order"
    },
    {
        path: "work_order_invoice",
        component: WorkOrderInvoice,
        id: "009",
        menuName: "Work Order Invoice",
        wrapperClass: "work_order_invoice"
    },
    {
        path: "invoice_return_work_order",
        component: InvoiceReturnWorkOrder,
        id: "016",
        menuName: "Invoice Return Work Order",
        wrapperClass: "invoice_return_work_order"
    },
    {
        path: "data_invoice_return_work_order",
        component: DataInvoiceReturnWorkOrder,
        id: "017",
        menuName: "Data Invoice Return Work Order",
        wrapperClass: "data_invoice_return_work_order"
    },
    {
        path: "data_invoice_work_order",
        component: data_invoice_work_order,
        id: "014",
        menuName: "Data Work Order Invoice",
        wrapperClass: "data_invoice_work_order"
    },
    {
        path: "supply_slip",
        component: SupplySlip,
        id: "010",
        menuName: "Supply Slip",
        wrapperClass: "supply_slip"
    },
    {
        path: "data_supply_slip",
        component: DataSupplySlip,
        id: "011",
        menuName: "Data Supply Slip",
        wrapperClass: "data_supply_slip"
    },
    {
        path: "supply_slip_return",
        component: supply_slip_return,
        id: "012",
        menuName: "Supply Slip Return",
        wrapperClass: "supply_slip_return"
    },
    {
        path: "data_supply_slip_return",
        component: DataSupplySlipReturn,
        id: "015",
        menuName: "Data Supply Slip Return",
        wrapperClass: "data_supply_slip_return"
    },
    {
        path: "setting_overtime_work_allocation",
        component: setting_overtime_work_allocation,
        id: "013",
        menuName: "Setting Overtime Work Allocation",
        wrapperClass: "setting_overtime_work_allocation"
    },
    {
        path: "sales_invoice_profit_report",
        component: sales_invoice_profit_report,
        id: "018",
        menuName: "Sales Invoice Profit Report",
        wrapperClass: "sales_invoice_profit_report"
    },
    {
        path: "status_import_spareparts_master",
        component: status_import_spareparts_master,
        id: "019",
        menuName: "Status Import Spareparts Master",
        wrapperClass: "status_import_spareparts_master"
    },
    {
        path: "menu_approval",
        component: menu_approval,
        id: "020",
        menuName: "Menu Approval",
        wrapperClass: "menu_approval"
    },
    {
        path: "rack_location",
        component: rack_location,
        id: "021",
        menuName: "List Location Rack",
        wrapperClass: "rack_location"
    },
     {
        path: "export_part",
        component: export_part,
        id: "023",
        menuName: "Export Data Stock Spareparts",
        wrapperClass: "export_part"
    },
     {
        path: "adjustment",
        component: adjustment,
        id: "024",
        menuName: "Adjustment",
        wrapperClass: "adjustment"
    },
     {
        path: "data_adjustment",
        component: data_adjustment,
        id: "025",
        menuName: "Data Adjustment",
        wrapperClass: "data_adjustment"
    },
    {
        path: "menu_sql",
        component: MenuSql,
        id: "026",
        menuName: "Menu Sql",
        wrapperClass: "menu_sql"
    },
    {
        path: "log_spareparts",
        component: LogSpareparts,
        id: "027",
        menuName: "Transaction Spareparts",
        wrapperClass: "log_spareparts"
    },
    {
        path: "work_order_report",
        component: WorkOrderReport,
        id: "028",
        menuName: "Work Order Report",
        wrapperClass: "work_order_report"
    },




];
